const { h, render, Component } = require('preact');
const GrouponValidate = require('../../../groupon/frontend/validate')

class Phone extends Component {
  constructor(props) {
    super(props);
    this.changePhoneBoxState = this.changePhoneBoxState.bind(this)
    this.isInputValid = this.isInputValid.bind(this)
    this.validateInput = this.validateInput.bind(this)
    this.readInput = this.readInput.bind(this)
    this.isInputGiven = this.isInputGiven.bind(this)
    this.populateInput = this.populateInput.bind(this)

  }

  changePhoneBoxState() {
    this.props.updateState(this.props.attrs.type, this.props.attrs.counter, this.populateInput(), this.validateInput())
  }

  getInputHtmlElement() {
    var elementId = "phone_number_input" + this.props.attrs.counter
    return document.getElementById(elementId)
  }

  isInputValid() {
    var phoneNumber = this.readInput()
    var isValidPhoneNumber = true
    if (phoneNumber != "") {
      if (I18n.country == "US") {
        isValidPhoneNumber = GrouponValidate.phone(phoneNumber)
      }
      else
        isValidPhoneNumber = GrouponValidate.phoneInternational(phoneNumber)
    }
    return isValidPhoneNumber
  }


  readInput() {
    return this.getInputHtmlElement().value.trim();
  }

  isInputGiven() {
    return this.getInputHtmlElement().value.trim().length > 0
  }

  validateInput() {
    if (this.props.attrs.required == "true") {
      return this.isInputGiven() && this.isInputValid()
    }
    else
      return true
  }

  componentDidMount() {
    var phoneMask = new IMask(this.getInputHtmlElement(), {
      mask: '(000)000-0000',
      lazy: false,  // make placeholder always visible
      placeholderChar: '_'     // defaults to '_'
    });
    var phoneElement = this.getInputHtmlElement()
    phoneElement.addEventListener("keyup", this.changePhoneBoxState)
  }


  populateInput() {
    var data = {}
    if (this.isInputGiven()) {
      data.user_given_phone = this.readInput()
    }
    return data
  }

  render() {
    let attrs = this.props.attrs
    return (
      <div>
        <label><strong>{attrs.label}</strong>
          {attrs.required == "true"? (<span class="mandatory-field"> * </span>) : null}</label>
        <input class="inputField phone_number_input" maxLength="250" placeholder="( ___ ) ___ - ____" type="text" name="contactPhone" data-bhw={'phone_input' + attrs.counter} aria-label={attrs.label} id = {"phone_number_input" + attrs.counter} />

        <span class="validatePhoneNumberInput invalid-input initially-hidden error" id = "validatePhoneNumberInput">
          {I18n.translate('js.modules.support.invalidphone')}
        </span>
      </div>
    )
  }
}

module.exports = Phone
